export const validateTripActivity = (a) => {
    let canSave = true;
    const errors = {};
    // console.log('validateActivity', a);
    if (!a.activity || a.activity.constructor !== Object) {
        console.log('validateActivity: not activity or constructor !== object', a.activity, a);
        if (a._changed_activity) {
            errors.activity = { error: true, helperText: "Activity is required" };
        }
        canSave = false;
    }
    return { canSave, errors };
}
